/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTEgMTVMMTUgMSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNNyAxNUwxNSA3TTEyIDE1TDE1IDEyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPg==";